// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--u9JXI","link":"_02712f2b3b--link--FuuVF"};